import React from 'react';
import classNames from 'classnames';

import { makeStyles, Button, PropTypes as MaterialTypes } from '@material-ui/core';

import { Icon } from '@hydra/common/components';

const useStyles = makeStyles(theme => ({
  button: {
    fontSize: theme.typography.fontSizeRoot,
    fontWeight: theme.typography.fontWeightBold
  },
  buttonText: { position: 'relative' },
  loadingSpinner: {
    position: 'absolute',
    left: theme.spacing(-3),
    top: theme.spacing(0.25)
  }
}));

type LoadingButtonProps = {
  className?: string,
  color?: MaterialTypes.Color,
  disabled?: boolean,
  fullWidth?: boolean,
  loading: boolean,
  loadingText?: string,
  onClick?: () => void | Promise<void>,
  size?: 'small' | 'medium' | 'large',
  text: string,
  type?: 'submit' | 'reset' | 'button',
  variant?: 'text' | 'outlined' | 'contained'
};

export default function LoadingButton ({ className, color, disabled, fullWidth, loading, loadingText, onClick, size, text, type, variant }: LoadingButtonProps) {
  const classes = useStyles();

  return (
    <Button
      className={classNames(classes.button, className)}
      color={color ?? 'primary'}
      disabled={disabled || loading}
      fullWidth={fullWidth}
      onClick={onClick}
      size={size}
      type={type ?? 'button'}
      variant={variant ?? 'contained'}
    >
      <div className={classes.buttonText}>
        {loading && <Icon type='loader' size='sm' className={classes.loadingSpinner} />}
        {!loading || !loadingText ? text : loadingText}
      </div>
    </Button>
  );
}
